import { formValueShouldBeNull } from "@/lib/componentUtil";

export default {
  computed: {
    value: {
      get() {
        const { attributeMap, attributeName } = this;

        return attributeMap[attributeName];
      },
      set(value) {
        const { attributeMap, attributeName } = this;

        if (formValueShouldBeNull(value)) {
          value = null;
        }

        // Add reactive property
        this.$set(attributeMap, attributeName, value);

        this.$emit("change", attributeMap);
      },
    },
  },
  model: {
    prop: "attributeMap",
    event: "change",
  },
  props: {
    attributeMap: {
      required: true,
      type: Object,
    },
    attributeName: {
      required: true,
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    helpText: {
      required: false,
      type: String,
    },
    mode: {
      required: true,
      type: String,
    },
    ruleList: {
      default: () => [],
      type: Array,
    },
  },
};
